import getConfig from "next/config";

const { publicRuntimeConfig  } = getConfig();

const gtagScript = (userId: string) => `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${publicRuntimeConfig.GTAG_ID}', {
    'user_id': '${userId}',
    'user_properties': {
      'id_catho': '${userId}'
    }
  });
`;

export {
  gtagScript
}